import React from 'react';

const Datenschutz = () => (
  <div className="bg-gray-50 min-h-screen py-16 px-4 md:px-10 lg:px-20 text-gray-800 font-light">
    <div className="max-w-4xl mx-auto bg-white shadow-md rounded-xl p-8 md:p-12 space-y-6">
      <h1 className="text-4xl font-bold text-main mb-6 border-b pb-4">
        Datenschutzerklärung
      </h1>

      <section className="space-y-3">
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein besonderes
          Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich
          auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TMG). In
          dieser Datenschutzerklärung informieren wir Sie über die
          wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer
          Website.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Kontakt mit uns</h2>
        <p>
          Wenn Sie per E-Mail Kontakt mit uns aufnehmen, werden Ihre
          angegebenen Daten (insbesondere E-Mail-Adresse und ggf.
          Name) zwecks Bearbeitung der Anfrage und für den Fall von
          Anschlussfragen bei uns gespeichert.
        </p>
        <p>
          Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Kinderanmeldung</h2>
        <p>
          Die übermittelten personenbezogenen Daten (wie Name des
          Kindes, E-Mail-Adresse der Eltern) im Rahmen der
          Kinderanmeldung werden ausschließlich zur Bearbeitung der
          Anmeldung und für organisatorische Zwecke verwendet.
        </p>
        <p>
          Die Daten werden nicht an Dritte weitergegeben und nur so
          lange gespeichert, wie es für den Anmeldeprozess und die
          Organisation des Schulbetriebs notwendig ist.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Cookies</h2>
        <p>
          Unsere Website verwendet keine Cookies oder vergleichbare
          Technologien zur Nutzerverfolgung.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Ihre Rechte</h2>
        <p>
          Ihnen stehen grundsätzlich die Rechte auf Auskunft,
          Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit,
          Widerruf und Widerspruch zu. Wenn Sie glauben, dass die
          Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt
          oder Ihre datenschutzrechtlichen Ansprüche sonst in einer
          Weise verletzt worden sind, können Sie sich bei der
          Aufsichtsbehörde beschweren.
        </p>
        <p>
          In Niedersachsen ist das die: <br />
          <a
            href="https://www.lfd.niedersachsen.de/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            Landesbeauftragte für den Datenschutz Niedersachsen
          </a>
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Kontakt</h2>
        <p>
          Arabische Schule in Braunschweig Annour e.V.
          <br />
          Petzvalstr. 50, 38104 Braunschweig
          <br />
          E-Mail:{' '}
          <a
            href="mailto:info@annour-bs.de"
            className="text-blue-600 underline"
          >
            info@annour-bs.de
          </a>
        </p>
      </section>
    </div>
  </div>
);

export default Datenschutz;
